import { useQuery } from '@provision/graphql-client';
import { useMemo } from 'react';
import { GET_WORKFLOW_STEP_TYPES_QUERY } from 'src/graphql/entities/workflow/workflow.operations';
import type {
  GetWorkflowStepTypesQuery,
  WorkflowCatalogTriggerType,
} from 'src/graphql/entities/workflow/workflow.types';
import {
  toWorkflowStepCatalog,
  type WorkflowStepCatalog,
} from 'src/pages/Settings/workflows/utils/workflow-definition';

const EMPTY_TRIGGER_TYPES: WorkflowCatalogTriggerType[] = [];

/**
 * The backend's description of every step type and trigger type (`getWorkflowStepTypes`). It is
 * static per deploy, so it is read once and served from the cache after that.
 */
export function useWorkflowStepTypes(): {
  catalog: WorkflowStepCatalog;
  triggerTypes: WorkflowCatalogTriggerType[];
  loading: boolean;
  error?: Error;
} {
  const { data, loading, error } = useQuery<GetWorkflowStepTypesQuery>(
    GET_WORKFLOW_STEP_TYPES_QUERY,
    { fetchPolicy: 'cache-first' },
  );

  const stepTypes = data?.getWorkflowStepTypes.stepTypes;
  const catalog = useMemo(() => toWorkflowStepCatalog(stepTypes ?? []), [stepTypes]);

  return {
    catalog,
    triggerTypes: data?.getWorkflowStepTypes.triggerTypes ?? EMPTY_TRIGGER_TYPES,
    loading,
    error,
  };
}
